module.exports = __webpack_public_path__ + "img/1577994402.41b7fd10.jpg";